import { apiFetch } from './client'

/**
 * s62 / PDF da descricao no modelo PES.001 (decisao de Marcelo 20/10/2026: P1 servidor, P2 so publicada vale documento
 * -- rascunho sai com marca d'agua, P3 codigo do formulario editavel por empresa).
 *   GET /api/job-descriptions/{id}/pdf   -> arquivo (description.read; rascunho so para quem edita)
 *   GET/PUT /api/description-form-code   -> codigo do formulario (PUT: tenant.update_basics)
 */

/** Nome do arquivo para salvar: <form>_<codigo>_v<n>[_RASCUNHO].pdf -- mesmo padrao do servidor. */
export function pdfFileName(form: string, jobCode: string, version: number, published: boolean): string {
  const base = `${form}_${jobCode}_v${version}`
    .normalize('NFKD')
    .replace(/[̀-ͯ]/g, '')
    .replace(/[^A-Za-z0-9._-]+/g, '_')
    .replace(/^_+|_+$/g, '')
  return `${base || 'descricao'}${published ? '' : '_RASCUNHO'}.pdf`
}

export async function downloadDescriptionPdf(descriptionId: string, fileName: string): Promise<void> {
  const blob = await apiFetch<Blob>(`/api/job-descriptions/${encodeURIComponent(descriptionId)}/pdf`, { blob: true })
  const url = URL.createObjectURL(blob)
  try {
    const a = document.createElement('a')
    a.href = url
    a.download = fileName
    document.body.appendChild(a)
    a.click()
    a.remove()
  } finally {
    setTimeout(() => URL.revokeObjectURL(url), 1000)
  }
}

export interface FormCode {
  formCode: string
  isDefault: boolean
}

export async function fetchFormCode(): Promise<FormCode> {
  const r = await apiFetch<{ form_code: string; is_default: boolean }>('/api/description-form-code')
  return { formCode: r.form_code, isDefault: r.is_default }
}

export async function saveFormCode(code: string | null): Promise<FormCode> {
  const r = await apiFetch<{ form_code: string; is_default: boolean }>('/api/description-form-code', {
    method: 'PUT',
    body: { form_code: code },
  })
  return { formCode: r.form_code, isDefault: r.is_default }
}

export const FORM_CODE_QUERY_KEY = ['description-form-code'] as const
